import React, {memo, FC} from "react";
import {Moment} from "moment";
import {FormikProps} from "formik";
import {TableProps} from "antd";
import {ArrayDataOptions, GetBookingsByCourseIdWithCourseLessonBookingsQuery, GetHolidaysByCompanyAndDateRangeQuery, Maybe, UpdateCourseAndBookingsInput} from "../../../generated/graphql";
import LessonTablePassive, {LessonBookingCourseLessonTableData} from "./LessonTablePassive";
import SummarySection from "../../../views/SummarySection/SummarySection";
import i18n from "../../../services/i18n";
import PaymentsPassive from "./PaymentLists/PaymentsPassive";
import Notes from "./Notes";
import css from "./LessonBookings.less";
import BookingHistoryDrawer from "../../bookingHistory/BookingHistoryDrawer";

//

type CurrentBookingProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
    getHolidayInfo: (date: Moment) => GetHolidaysByCompanyAndDateRangeQuery["holidaysByCompanyAndDateRange"][number] | undefined;
    formikProps: FormikProps<UpdateCourseAndBookingsInput>;
    pagination?: TableProps<LessonBookingCourseLessonTableData>["pagination"];
    options?: Maybe<ArrayDataOptions>;
    setOptions: (options: ArrayDataOptions) => void;
    changedPaymentIds?: {changedIds: Set<string>; addedIds: Set<string>; removedIds: Set<string>};
    isTotalPriceChanged?: boolean;
};

const CurrentBooking: FC<CurrentBookingProps> = ({booking, getHolidayInfo, formikProps, options, setOptions, pagination, changedPaymentIds, isTotalPriceChanged}) => {
    const {values} = formikProps;

    return (
        <div className={css.bookingRoot}>
            <SummarySection
                // className={css.summarySection}
                title={i18n.containers.bookings.BookingSummary.sectionHeaders.courseLessons()}
                content={<LessonTablePassive booking={booking} getHolidayInfo={getHolidayInfo} options={options} setOptions={setOptions} />}
                extra={<BookingHistoryDrawer bookingId={booking.id} buttonProps={{size: "small", type: "link"}} />}
            />
            <SummarySection
                style={{paddingTop: 0}}
                // style={{paddingTop: 4}}
                // style={{paddingTop: -12, marginTop: -5}}
                // style={{border: "1px solid red"}}
                className={css.summarySection}
                title={i18n.containers.bookings.BookingSummary.sectionHeaders.installmentRates()}
                content={<PaymentsPassive booking={booking} values={values} changedPaymentIds={changedPaymentIds} isTotalPriceChanged={isTotalPriceChanged} />}
            />
            <SummarySection className={css.summarySection} title={i18n.containers.bookings.BookingSummary.sectionHeaders.notes()} content={<Notes booking={booking} />} />
        </div>
    );
};

export default memo(CurrentBooking);
